// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Settings_context} from '../settings_ctx';
import {Navbar_logo} from '../ui/navbar/navbar_logo';
import {Link} from '../ui/link';
import {img_url} from '../ui/img_url';
import cn from 'classnames';
import styles from './mini_footer.module.less';

interface i_mini_footer_props {
    game_boost_like_footer?: boolean;
}

const Game_boost_footer = ()=>{
    const {theme} = useContext(Settings_context);
    return <footer className={styles.gb_footer}>
      <div className={styles.gb_top}>
        <img className={styles.gb_logo}
          src={img_url('logo/gameboost_header.svg')} alt="GameBoost" />
        <nav className={styles.gb_nav}>
          <Link className={cn([theme.p2_med, theme.color_n700])}
            to="https://hola.org/contact" target="_blank">Contact</Link>
          <Link className={cn([theme.p2_med, theme.color_n700])}
            to="/legal/privacy" target="_blank">Privacy Policy</Link>
          <Link className={cn([theme.p2_med, theme.color_n700])}
            to="https://bright-sdk.com/eula" target="_blank">Terms of Use</Link>
          <Link className={cn([theme.p2_med, theme.color_n700])}
            to="/faq" target="_blank">FAQ</Link>
        </nav>
      </div>
      <p className={cn([theme.u5, theme.color_n600, styles.gb_copyright])}>
        {'\u00A9 Copyright 2022 Hola VPN Ltd. | All rights reserved'}</p>
    </footer>;
};

export const Mini_footer = (props: i_mini_footer_props)=>{
    const {game_boost_like_footer} = props;
    const {theme} = useContext(Settings_context);
    if (game_boost_like_footer)
        return <Game_boost_footer />;
    return <footer className={theme.container}>
      <div className={styles.footer}>
        <div className={styles.logo_wrapper}>
          <Navbar_logo logo_cls={styles.logo} force_type={'basic'} disabled/>
        </div>
        <nav className={styles.nav}>
          <ul className={styles.nav_links}>
            <li className={styles.nav_link}>
              <Link className={cn([theme.link, theme.color_n700])}
                to="https://bright-sdk.com/eula" target="_blank">EULA</Link>
            </li>
            <li className={styles.nav_link}>
              <Link className={cn([theme.link, theme.color_n700])}
                to="/legal/privacy" target="_blank">Privacy</Link>
            </li>
            <li className={styles.nav_link}>
              <Link className={cn([theme.link, theme.color_n700])}
                to="/faq" target="_blank">FAQ</Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>;
};

export const Mini_footer_editor = props=>{
    return <Editor value={props.value} on_change={props.on_change}
      editors={[
        {key: 'game_boost_like_footer', label: 'Game boost like footer',
          type: 'boolean'},
      ]}/>;
};
